<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows mt-3">
  <div [ngSwitch]="type" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-2 field-label text-right-align">
      {{ 'grid-comp.power-inverter-data' | translate }} {{ index + 1 }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-2 field-label text-right-align">
      {{ 'grid-comp.generator-data' | translate }} {{ index + 1 }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-2 field-label text-right-align">
      {{ 'grid-comp.converter-data' | translate }} {{ index + 1 }}
    </label>
    <label class="ui-g-3 field-label text-right-align required">
      {{ 'grid-comp.manufacturer' | translate }}
    </label>
    <input
      class="form-control"
      type="text"
      pInputText
      [(ngModel)]="energyUnit.manufacturer"
      name="{{ type }}Manufacturer{{ index }}"
      #{{type}}Manufacturer{{index}}="ngModel"
      required
      [disabled]="isDisabled" />
  </div>
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label class="ui-g-5 field-label text-right-align required">
      {{ 'grid-comp.number-identical-units' | translate }}
    </label>
    <p-inputNumber
      class="form-control"
      [(ngModel)]="energyUnit.identical_units"
      name="{{ type }}identical_units{{ index }}"
      #{{type}}identical_units{{index}}="ngModel"
      required
      (ngModelChange)="identicalUnitsChange()"
      [disabled]="isDisabled"></p-inputNumber>
  </div>
</div>
<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows mb-5">
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label class="ui-g-5 field-label text-right-align required">
      {{ 'grid-comp.type' | translate }}
    </label>
    <input
      class="form-control"
      type="text"
      pInputText
      [(ngModel)]="energyUnit.type"
      name="{{ type }}Type{{ index }}"
      #{{type}}Type{{index}}="ngModel"
      required
      [disabled]="isDisabled" />
  </div>
  <div [ngSwitch]="type" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
    <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-5 field-label text-right-align required">
      {{ 'grid-comp.max-power-inverter-unit' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-5 field-label text-right-align required">
      {{ 'grid-comp.max-power-generator' | translate }}
    </label>
    <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-5 field-label text-right-align required">
      {{ 'grid-comp.converter-effective-power' | translate }}
    </label>
    <p-inputNumber
      class="form-control"
      [(ngModel)]="energyUnit.max_unit_power"
      name="{{ type }}max_unit_power{{ index }}"
      (keydown)="detectDecimalSeparator($event)"
      #{{type}}max_unit_power{{index}}="ngModel"
      mode="decimal"
      locale="de-DE"
      [minFractionDigits]="0"
      [maxFractionDigits]="3"
      required
      (ngModelChange)="maxPowerChange($event)"
      [disabled]="isDisabled"></p-inputNumber>
    <label class="ml-2">kW</label>
  </div>
</div>
<div [ngSwitch]="type" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
  <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.inverter-data-sheet' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.generator-data-sheet' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.converter-data-sheet' | translate }}
  </label>
  <app-file-upload
    [fileData]="productDataSheet"
    [type]="documentTypes.EnergyUnitDataSheet"
    [isDetailsView]="isDetailsView && productDataSheet?.document_id"
    [isClearButtonDisabled]="isDisabled"
    [isUploadDisabled]="isDisabled"
    [isRequired]="!isDisabled"
    [inputName]="type + 'sub_product_data_sheet' + index"
    (clearFileEvent)="clearFile($event)"></app-file-upload>
</div>
<div
  [ngSwitch]="type"
  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
  [class]="type === uiCollectionTypes.PowerConverter ? 'mt-3' : ''">
  <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.inverter-unit-certificate' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.generator-unit-certificate' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.converter-unit-certificate' | translate }}
  </label>
  <app-file-upload
    [fileData]="unitCertificate"
    [type]="documentTypes.UnitCertificate"
    [isDetailsView]="isDetailsView && unitCertificate?.document_id"
    [isClearButtonDisabled]="isDisabled"
    [isUploadDisabled]="isDisabled"
    [isRequired]="!isDisabled"
    [inputName]="type + 'unit_certificate' + index"
    (clearFileEvent)="clearFile($event)"></app-file-upload>
  <div
    *ngIf="index > 0"
    (click)="removeElement(energyUnit)"
    class="pi pi-trash pointer-cursor right-aligned ui-g-2"
    [ngClass]="isDisabled ? 'disable-section' : ''"></div>
</div>
<div *ngIf="energyUnit.max_unit_power > 52" [ngSwitch]="type" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
  <label *ngSwitchCase="uiCollectionTypes.PowerInverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.inverter-audit-report' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.Generator" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.generator-audit-report' | translate }}
  </label>
  <label *ngSwitchCase="uiCollectionTypes.PowerConverter" class="ui-g-2 field-label text-right-align required">
    {{ 'grid-comp.converter-audit-report' | translate }}
  </label>
  <app-file-upload
    [fileData]="auditReport"
    [type]="documentTypes.AuditReport"
    [isDetailsView]="isDetailsView && auditReport?.document_id"
    [isClearButtonDisabled]="isDisabled"
    [isUploadDisabled]="isDisabled"
    [isRequired]="!isDisabled"
    [inputName]="type + 'audit_report' + index"
    (clearFileEvent)="clearFile($event)"></app-file-upload>
</div>
